module.exports = __webpack_public_path__ + "assets/img/RM-RM448TC-AW-006.8f918cbe.jpg";